<template>
  <div class="container">
    <div class="step-container" v-if="!offline">
      <!-- steps: -->
      <CvcCarousel v-if="step === null" key="carousel" />
      <Kamer v-else key="kamer" />
    </div>
    <div class="step-container" v-if="offline">
      <Offline />
    </div>
    <Voorwaarden />
  </div>
</template>
<script>
import { mapState } from 'vuex';

import Voorwaarden from '../Voorwaarden';
import Offline from './components/Offline';
import CvcCarousel from '../../components/Carousel';
import Kamer from '@/components/Kamer';

export default {
  name: 'Steps',
  components: {
    Kamer,
    CvcCarousel,
    Offline,
    Voorwaarden,
  },
  computed: {
    ...mapState(['offline', 'step']),
  },
};
</script>
<style lang="scss" scoped>
.container {
  display: flex;
  flex-direction: column;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
.step-container {
}
</style>
